import { searchReducer } from "PFReducers/search_reducer/search_reducer";

const combineReducers = (reducers) => (state, action) =>
  reducers.reduce((mem, reducer) => ({ ...mem, ...(reducer(mem, action) || {}) }), state);

export const mainReducer = (state, action) => combineReducers([searchReducer])(state, action);
